import {
  AutocompleteInput,
  Datagrid,
  DateField,
  DateInput,
  EditButton,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ShowButton,
  TextField,
  useDataProvider,
  useGetList,
  useGetOne,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField as MuiTextField,
} from "@mui/material";
import { useCallback, useState } from "react";
import dayjs from "dayjs";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const filters = [
  <ReferenceInput source="contestId" reference="contest" alwaysOn>
    <SelectInput optionText={"name"} source="name" alwaysOn={true} />
  </ReferenceInput>,
];

export function ContestSubmissionList(props) {
  return (
    <List rowClick="show" {...props} filters={filters}>
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" />
        <ReferenceField source="contestId" reference="contest">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="childId" reference="child">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="submissionTime" showTime />
        <SelectWinners source="SelectWinners" />
        <EditButton />
        <ShowButton />
      </Datagrid>
    </List>
  );
}

export default function SelectWinners() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const record = useRecordContext();
  const [rank, setRank] = useState(1);
  const provider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const { data: contest } = useGetOne("contest", { id: record?.contestId });

  const { data: winners } = useGetList("contestWinner", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "rank", order: "ASC" },
    filter: { contestId: record?.contestId },
  });

  const ifAlreadyMarked = useCallback((submissionId) => {
    if (!winners || winners.length === 0) {
      return false;
    }
    for (let i = 0; i < winners.length; i++) {
      if (winners[i].submissionId === submissionId) {
        return true;
        break;
      }
    }
  }, winners);

  const ifChildAlreadyAWinner = useCallback((childId) => {
    if (!winners || winners.length === 0) {
      return false;
    }
    for (let i = 0; i < winners.length; i++) {
      if (winners[i].childId === childId) {
        return true;
        break;
      }
    }
  }, winners);

  const ifRankAlreadyMarked = useCallback((rank) => {
    if (!winners || winners.length === 0) {
      return false;
    }
    for (let i = 0; i < winners.length; i++) {
      if (winners[i].rank === rank) {
        return true;
        break;
      }
    }
  }, winners);

  //   console.log("winners", winners);

  const createWinner = useCallback(
    ({ contestId, submissionId, childId, rank }) => {
      provider
        .create("contestWinner", {
          data: {
            contestId: contestId,
            submissionId: submissionId,
            childId: childId,
            rank: rank,
          },
        })
        .then(({ data }) => {
          console.log(data, "contestWinner create data");
          if (data?.rank) {
            refresh();
            notify(`Contest Winner created successfully`, { type: "success" });
            // handleClose();
          } else {
            notify("Error Creating Contest Winner", { type: "error" });
          }
        })
        .catch((err) => {
          console.log(err);
          notify("Something went wrong", { type: "error" });
        });
    },
  );

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        sx={{ width: "200" }}
        onClick={handleOpen}
      >
        Select Winners
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h1">
            Select Winners
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Box>Contest : {contest?.name}</Box>
            <Box>
              Start Date :{" "}
              {dayjs(contest?.startDate).format("DD MMM, YYYY hh:mm a")}{" "}
            </Box>
            <Box>
              End Date : {dayjs(contest?.endDate).format("DD MM, YYYY hh:mm a")}
            </Box>
            <Box>
              Contest Submitted Date :{" "}
              {dayjs(record?.createdDate).format("DD MMM, YYYY hh:mm a")}
            </Box>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Box>Winners</Box>
            <List
              resource="contestWinner"
              filter={{ contestId: record?.contestId }}
              actions={<></>}
            >
              <Datagrid rowClick="" bulkActionButtons={false}>
                <TextField source="rank" />
                <ReferenceField source="childId" reference="child">
                  <TextField source="name" />
                </ReferenceField>
                <DateField source="createdDate" showTime />
              </Datagrid>
            </List>
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {ifAlreadyMarked(record?.id) ? (
              <>This Submission is already marked as winner</>
            ) : (
              <></>
            )}
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {ifChildAlreadyAWinner(record?.childId) ? (
              <>This Child is already marked as winner</>
            ) : (
              <></>
            )}
          </Typography>

          {!ifAlreadyMarked(record?.id) &&
            !ifChildAlreadyAWinner(record?.childId) && (
              <Typography
                id="modal-modal-description"
                sx={{
                  mt: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "250px",
                }}
              >
                <MuiTextField
                  type="number"
                  min={1}
                  onChange={(e) => setRank(e.target.value)}
                  value={rank}
                />
                <Box>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ width: "200" }}
                    onClick={() => {
                      if (!rank) {
                        notify("Please enter rank", { type: "error" });
                        return;
                      }

                      if (ifRankAlreadyMarked(rank)) {
                        notify("Rank already taken by another child", {
                          type: "error",
                        });
                        return;
                      }

                      createWinner({
                        contestId: record?.contestId,
                        submissionId: record?.id,
                        childId: record?.childId,
                        rank: rank,
                      });
                    }}
                  >
                    Add Winner
                  </Button>
                </Box>
              </Typography>
            )}
        </Box>
      </Modal>
    </div>
  );
}
